import Skeleton from '@material-ui/lab/Skeleton';
import React from 'react';

export default function LoadingState() {
	return (
		<div>
			<p className='text-15 p-10'>Aktualności</p>
			{[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24].map(item => (
				<div key={item} className='flex flex-col items-center justify-center'>
					<div className='flex flex-row items-start justify-center'>
						<div><Skeleton variant="circle" width='10vw' height='10vw' /></div>
						<div><Skeleton className='ml-05' width='78vw' height='3rem' /></div>
					</div>
					<Skeleton variant="rect" className='mx-auto mt-10 mb-15' width='90vw' height='12rem' />
				</div>
			))}
		</div>
	);
}
